window.addEventListener('DOMContentLoaded', event => {

    // Toggle the side navigation
    const sidebarToggle = document.body.querySelector('#sidebarToggle');
    if (sidebarToggle) {
        // Uncomment Below to persist sidebar toggle between refreshes
        // if (localStorage.getItem('sb|sidebar-toggle') === 'true') {
        //     document.body.classList.toggle('sb-sidenav-toggled');
        // }
        sidebarToggle.addEventListener('click', event => {
            event.preventDefault();
            document.body.classList.toggle('sb-sidenav-toggled');
            localStorage.setItem('sb|sidebar-toggle', document.body.classList.contains('sb-sidenav-toggled'));
        });
    }

    var yearCopyright = document.body.querySelector('#year-copyright');

    if(yearCopyright) {
        yearCopyright.innerHTML = getCurrentYear();
    }

});

window.getCurrentYear=function() {
    var date = new Date();
    var currentYear = date.getFullYear();
    return currentYear;
}

window.fade = function(id, io, tm=7)
{
    var el = document.getElementById(id);
    if(el) {
        setTimeout(removeElement, tm*1000, id);
        io == "in" ? el.style.opacity = 1 : el.style.opacity = 0;
        el.style.transition = "opacity " + tm + "s";
        el.style.WebkitTransition = "opacity " + tm + "s";
    }
}

window.removeElement = function(id) {
    var el = document.getElementById(id);
    if(el) {
        el.remove();
    }
}


window.checkNewAnagrafia = function(ckeckBoxName, value) {

    var elemDaNascondere    = null;
    var elemDaVisualizzare  = null;
    var elemCheck           = null;
    var elemSelect          = null;
    var elemInput           = null;

    try {
        switch(ckeckBoxName) {
            case "ckeck_new_committente":

                elemCheck   = document.getElementById("ckeck_new_committente");
                elemSelect  = document.getElementById("id_committente");
                elemInput   = document.getElementById("nuovo_committente");

            break;

            case "ckeck_new_controparte":
                elemCheck   = document.getElementById("ckeck_new_controparte");
                elemSelect  = document.getElementById("id_controparte");
                elemInput   = document.getElementById("nuova_controparte");
            break;
        }

        if(elemCheck.checked) {
            elemDaNascondere    = elemSelect;
            elemDaVisualizzare  = elemInput;
            elemDaNascondere.setAttribute("hidden", "hidden");
            elemDaVisualizzare.removeAttribute("type");

        }
        else {
            elemDaNascondere    = elemInput;
            elemDaVisualizzare  = elemSelect;
            elemDaNascondere.setAttribute("type", "hidden");
            elemDaVisualizzare.removeAttribute("hidden");
        }

        elemDaNascondere.value = null;
        elemDaNascondere.required = false;
        elemDaVisualizzare.required = true;
    }
    catch(e) {}
}
